import { OptionProps } from './Form.types';
import { ErrorExpressionsMap } from '../../../shared/hooks/useValidator';

export const TERMS: OptionProps[] = [
  {
    text: '24 meses',
    value: '24',
  },
  {
    text: '36 meses',
    value: '36',
  },
  {
    text: '48 meses',
    value: '48',
  },
  {
    text: '60 meses',
    value: '60',
  },
];

export const PURCHASE_INTENT_OPTIONS: OptionProps[] = [
  {
    text: 'Menos de 2 semanas',
    value: 'LESS_THAN_TWO_WEEKS',
  },
  {
    text: 'Dentro de 1 mes',
    value: 'WITHIN_A_MONTH',
  },
  {
    text: 'Solo quiero simular',
    value: 'JUST_SIMULATE',
  },
];

export enum INPUT_NAMES {
  TERM = 'TERM',
  DOWN_PAYMENT = 'DOWN_PAYMENT',
  PHONE = 'PHONE',
  PURCHASE_INTENT = 'PURCHASE_INTENT',
}

export const errorExpressions: ErrorExpressionsMap = {
  [INPUT_NAMES.TERM]: [
    {
      format: /./,
      errorMessage: 'Selecciona un plazo antes de continuar',
    },
  ],
  [INPUT_NAMES.DOWN_PAYMENT]: [
    {
      format: /\d+/,
      errorMessage: 'Ingresa el enganche para el auto',
    },
    {
      format: (downPayment: string, price: unknown): boolean =>
        +downPayment >= 0.2 * (price as number),
      errorMessage:
        'El enganche mínimo para este auto es de: ',
    },
    {
      format: (downPayment: string, price: unknown): boolean =>
        +downPayment < (price as number),
      errorMessage: 'El enganche no puede ser mayor o igual al precio',
    },
  ],
  [INPUT_NAMES.PHONE]: [
    {
      format: /./,
      errorMessage: 'Ingresa tu número celular',
    },
    {
      format: /^\d{10}$/,
      errorMessage: 'El número de teléfono debe tener 10 caracteres',
    },
  ],
  [INPUT_NAMES.PURCHASE_INTENT]: [
    {
      format: /./,
      errorMessage: 'Selecciona una opción antes de continuar',
    },
  ],
};

export const BUTTON_TEST_ID = 'AUTO_EXTERNAL_FORM_BUTTON';
